import { post, put, get } from '../Services/http';
import { load as loadCart, receive } from './Cart.action';
import { catchError } from './Error.action';
import { hideCustomizedMessage, updateCustomizedMessage } from '../Actions/CustomizedMessage.action';
import { translate } from '../Services/translation';

import {
  CHECKOUT_SUBMIT,
  CHECKOUT_SUBMIT_ERROR,
  CHECKOUT_SET_CUSTOMER_INFO,
  CHECKOUT_SET_ORDER_NOTE,
  CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  CHECKOUT_SET_PRIVATE_CUSTOMER,
  CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
  CHECKOUT_SET_SIGN_UP,
  CHECKOUT_SET_COUNTRY,
  CHECKOUT_SET_SELECTED_CERTIFICATE,
  CHECKOUT_SET_DELIVERY_CONTACT_PERSON,
  CHECKOUT_SET_SELECTED_DELIVERY_CONTACT_PERSON_PHONE,
  CHECKOUT_SET_ORDER_MARKING,
  CHECKOUT_SET_CUSTOM_NOTE,
  CHECKOUT_SET_PICKING_INSTRUCTIONS,
  CHECKOUT_SET_PACKING_INSTRUCTIONS,
  CHECKOUT_SET_TRANSPORTATION_INSTRUCTIONS,
  CHECKOUT_SET_SELECTED_SALES_REP,
  CHECKOUT_SET_IS_VALID_FORM,
  CART_RECEIVE,
  CHECKOUT_SAVE_CART_ON_PURCHASE,
  CHECKOUT_SET_SHIPMENT_WIDGET,
  CHECKOUT_SET_SHIPPING_OPTION
} from '../constants';

export const setCountry = (systemId) => (dispatch, getState) => {
  initSubmit(dispatch);
  setCreateLineUpdateMessage(dispatch);
  dispatch({
    type: CHECKOUT_SET_COUNTRY,
    payload: {
      selectedCountry: systemId,
    },
  });
  const { payload } = getState().checkout;
  return put('/api/checkout/setCountry', payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
    })
    .catch((ex) => {
      dispatch(receive({ isComplete: true }));
      dispatch(catchError(ex, (error) => submitError(error)));
      dispatch(hideCustomizedMessage());
    })
    .finally(() => {
      completeSubmit(dispatch);
    });
};

export const setAddress = (systemId) => (dispatch, getState) => {
  initSubmit(dispatch);
  setCreateLineUpdateMessage(dispatch);
  if (systemId) {
    dispatch({
      type: CHECKOUT_SET_COUNTRY,
      payload: {
        selectedCountry: systemId,
      },
    });
  }
  const { payload } = getState().checkout;
  return put('/api/checkout/setAddress', payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
    })
    .catch((ex) => {
      dispatch(receive({ isComplete: true }));
      dispatch(catchError(ex, (error) => submitError(error)));
      dispatch(hideCustomizedMessage());
    })
    .finally(() => {
      completeSubmit(dispatch);
    });
};

const _submit = (url, model, dispatch) => {
  return post(url, model)
    .then((response) => response.json())
    .then((result) => {
      dispatch(orderSubmitDone(result));
    })
    .catch((ex) => {
      if (ex.response) {
        ex.response.json().then((error) => {
          dispatch(submitError(error));
          dispatch(orderSubmitDone(null));
          dispatch(loadCart());
        });
      } else {
        dispatch(submitError(ex));
      }
    });
};

export const updatePreferredDeliveryDate = (value) => (dispatch, getState) => {
  const { payload } = getState().checkout;
  initSubmit(dispatch);
  setCreateLineUpdateMessage(dispatch);

  payload.preferredDeliveryDate = value.preferredDeliveryDate;
  return put('/api/checkout/setPreferredDeliveryDate', payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
    })
    .catch((ex) => {
      dispatch(receive({ isComplete: true }));
      dispatch(catchError(ex, (error) => submitError(error)));
      dispatch(hideCustomizedMessage());
    })
    .finally(() => {
      completeSubmit(dispatch);
    });
};

export const updateCoFreight = (value) => (dispatch, getState) => {
  initSubmit(dispatch);
  setCreateLineUpdateMessage(dispatch);

  const { payload } = getState().checkout;
  payload.oneDelivery = value.preferredCoFreight;
  return put('/api/checkout/setCoFreight', payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
    })
    .catch((ex) => {
      dispatch(receive({ isComplete: true }));
      dispatch(catchError(ex, (error) => submitError(error)));
      dispatch(hideCustomizedMessage());
    })
    .finally(() => {
      completeSubmit(dispatch);
    });
};

export const clearAllCart = () => (dispatch) => {
  initSubmit(dispatch);
  return get('/api/cart/clearallcart')
    .then((response) => response.json())
    .then((cart) => {
      dispatch({
        type: CART_RECEIVE,
        payload: cart,
      });
      window.location.reload();
    })
    .catch((ex) => {
      dispatch(receive({ isComplete: true }));
      dispatch(catchError(ex, (error) => submitError(error)));
      completeSubmit(dispatch);
    });
};

export const setBusinessCustomer = (isBusinessCustomer) => ({
  type: CHECKOUT_SET_PRIVATE_CUSTOMER,
  payload: {
    isBusinessCustomer,
  },
});

export const submit = () => (dispatch, getState) => {
  const { payload } = getState().checkout;
  return _submit('/api/checkout/placeorder', payload, dispatch);
};

export const setSignUp = (signUp) => ({
  type: CHECKOUT_SET_SIGN_UP,
  payload: {
    signUp,
  },
});

export const setAlternativeAddress = (propName, value) => ({
  type: CHECKOUT_SET_CUSTOMER_INFO,
  payload: {
    key: 'alternativeAddress',
    data: {
      [propName]: value,
    },
  },
});

export const setCustomerDetails = (propName, value) => ({
  type: CHECKOUT_SET_CUSTOMER_INFO,
  payload: {
    key: 'customerDetails',
    data: {
      [propName]: value,
    },
  },
});

export const setSelectedCompanyAddress = (selectedCompanyAddressId) => ({
  type: CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
  payload: {
    selectedCompanyAddressId,
  },
});

export const setOrderNote = (orderNote) => ({
  type: CHECKOUT_SET_ORDER_NOTE,
  payload: {
    orderNote,
  },
});

export const acceptTermsOfCondition = (acceptTermsOfCondition) => ({
  type: CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  payload: {
    acceptTermsOfCondition,
  },
});

export const submitRequest = () => ({
  type: CHECKOUT_SUBMIT,
  payload: {
    isSubmitting: true,
    errors: {},
  },
});

export const submitDone = () => ({
  type: CHECKOUT_SUBMIT,
  payload: {
    isSubmitting: false,
    result: undefined,
  },
});

export const orderSubmitDone = (result) => ({
  type: CHECKOUT_SUBMIT,
  payload: {
    isSubmitting: false,
    result,
  },
});

export const submitError = (error) => ({
  type: CHECKOUT_SUBMIT_ERROR,
  payload: {
    error,
  },
});
export const setSelectedCertificateId = (value) => ({
  type: CHECKOUT_SET_SELECTED_CERTIFICATE,
  payload: {
    selectedCertificateId: value,
  },
});
export const setSelectedSalesRepId = (value) => ({
  type: CHECKOUT_SET_SELECTED_SALES_REP,
  payload: {
    selectedSalesRepId: value,
  },
});
export const setDeliveryContactPerson = (value) => ({
  type: CHECKOUT_SET_DELIVERY_CONTACT_PERSON,
  payload: {
    deliveryContactPersonName: value,
  },
});
export const setDeliveryContactPersonPhoneNumber = (value) => ({
  type: CHECKOUT_SET_SELECTED_DELIVERY_CONTACT_PERSON_PHONE,
  payload: {
    deliveryContactPersonPhoneNumber: value,
  },
});
export const setOrderMarking = (value) => ({
  type: CHECKOUT_SET_ORDER_MARKING,
  payload: {
    orderMarking: value,
  },
});

export const setCustomNote = (value) => ({
  type: CHECKOUT_SET_CUSTOM_NOTE,
  payload: {
    customNote: value,
  },
});

export const setPickingInstructions = (value) => ({
  type: CHECKOUT_SET_PICKING_INSTRUCTIONS,
  payload: {
    pickingInstruction: value,
  },
});

export const setPackingInstructions = (value) => ({
  type: CHECKOUT_SET_PACKING_INSTRUCTIONS,
  payload: {
    packingInstruction: value,
  },
});

export const setTransportationInstruction = (value) => ({
  type: CHECKOUT_SET_TRANSPORTATION_INSTRUCTIONS,
  payload: {
    transportationInstruction: value,
  },
});

export const setIsValidForm = (isValidForm) => ({
  type: CHECKOUT_SET_IS_VALID_FORM,
  payload: {
    isValidForm,
  },
});

export const initSubmit = (dispatch) => {
  dispatch(receive({ isComplete: false }));
  dispatch(submitRequest());
};

export const completeSubmit = (dispatch) => {
  dispatch(submitDone());
};

const setCreateLineUpdateMessage = (dispatch) => {
  dispatch(updateCustomizedMessage(translate('checkout.customizedmessage.createline.update')));
};

export const saveCartOnPurchase = (saveCartOnPurchase) => ({
  type: CHECKOUT_SAVE_CART_ON_PURCHASE,
  payload: {
    saveCartOnPurchase,
  },
});

export const reloadShipment = () => (dispatch, getState) => {
  const { payload } = getState().checkout;
  return put('/api/checkout/reloadShipmentWidget', payload)
      .then((response) => response.json())
      .then((result) => {
          if (result && result.shipmentWidget) {
              dispatch(setShipmentWidget(result.shipmentWidget));
          }
      })
      .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const setShippingOption = ({ shippingInfo, onSuccess, onError }) => (
  dispatch,
  getState
) => {
  const { payload } = getState().checkout;
  return put('/api/checkout/setShippingOption', {
      ...payload,
      shippingInfo,
  })
      .then((response) => response.json())
      .then((result) => {
          if (result?.paymentWidget) {
              dispatch(setPaymentWidget(result.paymentWidget));
          }
          dispatch(setSelectedShippingOption(shippingInfo));
          dispatch(loadCart());
          onSuccess && onSuccess();
      })
      .catch((ex) =>
          dispatch(
              catchError(ex, (error) => {
                  submitError(error);
                  onError && onError();
              })
          )
      );
};

const setSelectedShippingOption = (shippingInfo) => ({
  type: CHECKOUT_SET_SHIPPING_OPTION,
  payload: {
      shippingInfo,
  },
});

const setShipmentWidget = (shipmentWidget) => ({
  type: CHECKOUT_SET_SHIPMENT_WIDGET,
  payload: {
      shipmentWidget,
  },
});
